var _rect, _circle, _path, _circle2, _path2, _g, _rect2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_86)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_86)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.5,
    filter: "url(#filter1_f_0_86)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.5238,
    r: 7,
    fill: "url(#paint0_linear_0_86)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6069 30.6646L30.9178 28.6889H28.9726V27.4073C28.9726 26.8667 29.2438 26.3393 30.1151 26.3393H31V24.6573C31 24.6573 30.1973 24.5238 29.4301 24.5238C27.8274 24.5238 26.7808 25.4703 26.7808 27.183V28.6889H25V30.6646H26.7808V35.441C27.1384 35.4958 27.5041 35.5238 27.8767 35.5238C28.2493 35.5238 28.6151 35.4958 28.9726 35.441V30.6646H30.6069Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.5238,
    r: 7,
    fill: "url(#paint1_linear_0_86)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6069 30.6646L30.9178 28.6889H28.9726V27.4073C28.9726 26.8667 29.2438 26.3393 30.1151 26.3393H31V24.6573C31 24.6573 30.1973 24.5238 29.4301 24.5238C27.8274 24.5238 26.7808 25.4703 26.7808 27.183V28.6889H25V30.6646H26.7808V35.441C27.1384 35.4958 27.5041 35.5238 27.8767 35.5238C28.2493 35.5238 28.6151 35.4958 28.9726 35.441V30.6646H30.6069Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_86)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 42.0238,
    rx: 11.5,
    ry: 6.5,
    fill: "#0A77E8"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 12.6238,
    width: 31.8,
    height: 31.8,
    rx: 15.9,
    stroke: "url(#paint2_radial_0_86)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter3_f_0_86)"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29.5238,
    r: 9,
    fill: "white",
    fillOpacity: 0.18
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_86",
    x: 2,
    y: 2.5238,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_86"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_86",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_86",
    x: 8,
    y: 8.5238,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_0_86"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_86",
    x: -3,
    y: 17.5238,
    width: 59,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_0_86"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_86",
    x: 0,
    y: 0.523804,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_0_86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_86",
    x1: 28,
    y1: 21.5238,
    x2: 28,
    y2: 35.4823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_86",
    x1: 28,
    y1: 21.5238,
    x2: 28,
    y2: 35.4823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_86",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2878 13.4759) rotate(44.0741) scale(43.4569 69.503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.25d44a4c40c782f3abd83e14d85ff29d.svg";
export { ForwardRef as ReactComponent };